import { ConnectionDialogModule } from './../../shared/dialog/connection-dialog/connection.dialog.module';
import { AppListingModule } from './../../shared/app-listing/app-listing.module';
import { SnackbarModule } from './../../shared/snackbar/snackbar.module';
import { GooglepickerModule } from './../../shared/googlepicker/googlepicker.module';
import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionListingComponent } from './connection/connection-listing/connection-listing.component';
import { OrganizationRoutingModule } from './organization-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { BoxfilterPipe } from './connection/pipe/boxfilter.pipe';
import { ConnectionFilter } from './connection/pipe/connectionfilter.pipe';
import { ConnectionAppListingComponent } from './connection/connection-app-listing/connection-app-listing.component';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { SpecializedPanelsModule } from "src/app/bloom/specialized-panels/specialized-panels.module";
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { NewConnectionModule } from './connection/new-connection/new-connection.module';
import { ConnectionExplorerComponent } from './connection/connection-explorer/connection-explorer.component';
import { InputparameterDialogComponent } from './connection/connection-explorer/inputparameter-dialog/inputparameter-dialog.component';
import { workspaceModule } from 'src/app/shared/workspace/workspace.module';
import { ParameterInputsModule } from 'src/app/shared/parameter-inputs/parameter-inputs.module';
import { ObjectParameterInputsModule } from 'src/app/shared/input-parameters/object-parameter-inputs/object-parameter-inputs.module'
import { AttributeParameterInputsModule } from 'src/app/shared/input-parameters/attribute-parameter-inputs/attribute-parameter-inputs.module'
import { CustomObjectAttributeDialogComponent } from './connection/connection-explorer/custom-object-attribute-dialog/custom-object-dialog.component';
import { ConnectionExplorerSidePanelComponent } from './connection/connection-explorer/connection-explorer-side-panel/connection-explorer-side-panel.component';
import { BloomWithoutRoutingModule } from 'src/app/bloom/bloom-without-routing.module';
import { ConnectionExplorerDeleteRecordDialogComponent } from './connection/connection-explorer/connection-explorer-delete-record-dialog/connection-explorer-delete-record-dialog.component';
import { BoxPickerModule } from 'src/app/shared/box-picker/box-picker.module';
import { DisplayBannerModule } from 'src/app/shared/display-banner/display-banner.module';
import { QoutaPopupModule } from 'src/app/shared/qouta-popup/qouta.popup.module';
import { ConnectionCollaborationComponent } from './connection/connection-collaboration/connection-collaboration/connection-collaboration.component';
import { CommonMemberModule } from 'src/app/shared/common-member/common-member.module';
import { ResourceCollaborationModule } from "../../shared/resource-collaboration/resource-collaboration.module";
import { ListPublishingDialogModule } from 'src/app/shared/list-publishing-dialog/list-publishing-dialog.module';
import { ObjectExplorerModule } from 'src/app/shared/object-explorer/object-explorer.module';
import { ConnectionInfoHeaderComponent } from 'src/app/shared/connection-info-header/connection-info-header.component';
import { ObjectsListingComponent } from './connection/connection-explorer/objects-listing/objects-listing.component';
import { ActionsListingComponent } from './connection/connection-explorer/actions-listing/actions-listing.component';
import { EventsListingComponent } from './connection/connection-explorer/events-listing/events-listing.component';
import { AttributeSelectionModule } from "../../shared/query-components/attribute-selection/attribute-selection.module";
import { CollectActionDataComponent } from "../../shared/collect-action-data/collect-action-data.component";

@NgModule({
    declarations: [
        ConnectionListingComponent,
        BoxfilterPipe,
        ConnectionAppListingComponent,
        CustomObjectAttributeDialogComponent,
        ConnectionFilter,
        ConnectionExplorerComponent,
        InputparameterDialogComponent,
        ConnectionExplorerSidePanelComponent,
        ConnectionExplorerDeleteRecordDialogComponent,
        ConnectionCollaborationComponent
    ],
    providers: [
    // {provide: ErrorHandler, useClass: GlobalErrorHandler}
    ],
    exports: [
    // NewConnectionComponent
    ],
    imports: [
    workspaceModule,
    CommonModule,
    CommonMemberModule,
    OrganizationRoutingModule,
    SharedModule,
    SpinnerModule,
    GooglepickerModule,
    SnackbarModule,
    AppListingModule,
    ConnectionDialogModule,
    NewConnectionModule,
    ListPanelModule,
    ParameterInputsModule,
    BoxPickerModule,
    ObjectParameterInputsModule,
    AttributeParameterInputsModule,
    SpecializedPanelsModule,
    BloomWithoutRoutingModule,
    DisplayBannerModule,
    QoutaPopupModule,
    // ListPanelModule
    ResourceCollaborationModule,
    ListPublishingDialogModule,
    ObjectExplorerModule,
    ConnectionInfoHeaderComponent,
    ObjectsListingComponent,
    ActionsListingComponent,
    EventsListingComponent,
    AttributeSelectionModule,
    CollectActionDataComponent
]
})
export class OrganizationModule { }
